import React from "react";
import "./footer.css";

const footer = () => {
  return (
    <footer>
      <div>
        <a href="https://github.com/neqts">Designed & Built by Tomasz Topór</a>
      </div>
    </footer>
  );
};

export default footer;
